import React, { useRef, useState, useEffect } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Button, Input, Space, Table, Spin } from "antd";
import Highlighter from "react-highlight-words";
import { getApiWithAuth } from "../../../utils/api";
import { Url } from "../../../utils/apiUrl";

const ClubUserAnalytics = ({ clubId }) => {
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [users, setUsers] = useState([]);
  const searchInput = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const getAllStudentRecord = async () => {
    setIsLoading(true);
    const response = await getApiWithAuth(`${Url.coatHungingTime}${clubId}`);
    if (response.success) settingTableData(response.data);
    setIsLoading(false);
  };

  const settingTableData = (data) => {
    let usersArray = [];
    data.map((user) => {
      usersArray.push({
        key: user.user._id,
        email: user.user.email,
        averageTime: `${Math.floor(
          user["Average time in minutes"] / 60
        )} Hours : ${user["Average time in minutes"] % 60} Minutes`,
        totalTime: `${Math.floor(user["Total Time in minutes"] / 60)} Hours : ${
          user["Total Time in minutes"] % 60
        } Minutes`,
      });
    });
    setUsers(usersArray);
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "40%",
      ...getColumnSearchProps("email"),
    },
    {
      title: "Average Time",
      dataIndex: "averageTime",
      key: "averageTime",
      width: "30%",
    },
    {
      title: "Total Time",
      dataIndex: "totalTime",
      key: "totalTime",
    },
  ];
  useEffect(() => {
    getAllStudentRecord();
  }, [clubId]);

  return (
    <>
      {isLoading ? (
        <Spin tip="Loading" size="large" style={{ width: "100%" }} />
      ) : (
        <Table columns={columns} dataSource={users} pagination={false} />
      )}
    </>
  );
};
export default ClubUserAnalytics;
